import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

type IconProps = {
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
  fillColor?: string;
  width?: number;
  height?: number;
};

export const ExportIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon=Download">
      <path
        id="icon"
        d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);

export const ImportIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 8L17 13L15.6 14.45L13 11.85L13 20L11 20L11 11.85L8.4 14.45L7 13L12 8ZM18 4C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6L20 9L18 9L18 6L6 6L6 9L4 9L4 6C4 5.45 4.19583 4.97916 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4L18 4Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      d="M9.74994 10.7503L5.91661 6.91699L4.74994 8.08366L9.74994 13.0837L14.7499 8.08366L13.5833 6.91699L9.74994 10.7503Z"
      fill="currentColor"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.7556 16L9.15556 10.4C8.71111 10.7556 8.2 11.037 7.62222 11.2444C7.04444 11.4519 6.42963 11.5556 5.77778 11.5556C4.16296 11.5556 2.7963 10.9963 1.67778 9.87778C0.559259 8.75926 0 7.39259 0 5.77778C0 4.16296 0.559259 2.7963 1.67778 1.67778C2.7963 0.559259 4.16296 0 5.77778 0C7.39259 0 8.75926 0.559259 9.87778 1.67778C10.9963 2.7963 11.5556 4.16296 11.5556 5.77778C11.5556 6.42963 11.4519 7.04444 11.2444 7.62222C11.037 8.2 10.7556 8.71111 10.4 9.15556L16 14.7556L14.7556 16ZM5.77778 9.77778C6.88889 9.77778 7.83333 9.38889 8.61111 8.61111C9.38889 7.83333 9.77778 6.88889 9.77778 5.77778C9.77778 4.66667 9.38889 3.72222 8.61111 2.94444C7.83333 2.16667 6.88889 1.77778 5.77778 1.77778C4.66667 1.77778 3.72222 2.16667 2.94444 2.94444C2.16667 3.72222 1.77778 4.66667 1.77778 5.77778C1.77778 6.88889 2.16667 7.83333 2.94444 8.61111C3.72222 9.38889 4.66667 9.77778 5.77778 9.77778Z"
      fill="#C4C4C4"
    />
  </svg>
);

export function BrokenImageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200v-264l120 120 160-160 160 160 160-160 120 120v184q0 33-23.5 56.5T760-120H200Zm0-720h560q33 0 56.5 23.5T840-760v263L720-617 560-457 400-617 240-457 120-577v-183q0-33 23.5-56.5T200-840Z" />
    </svg>
  );
}

export function CatalogIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M560-564v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-600q-38 0-73 9.5T560-564Zm0 220v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-380q-38 0-73 9t-67 27Zm0-110v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-490q-38 0-73 9.5T560-454Zm-40 176q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q47-23 96.5-35.5T260-800q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 101.5 12.5T898-752q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59Z" />
    </svg>
  );
}

export function ComponentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M360-360v-240h240v240H360Zm0 240v-80h-80q-33 0-56.5-23.5T200-280v-80h-80v-80h80v-80h-80v-80h80v-80q0-33 23.5-56.5T280-760h80v-80h80v80h80v-80h80v80h80q33 0 56.5 23.5T760-680v80h80v80h-80v80h80v80h-80v80q0 33-23.5 56.5T680-200h-80v80h-80v-80h-80v80h-80Zm320-160v-400H280v400h400Z" />
    </svg>
  );
}

export function TemplateIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M480-118 120-398l66-50 294 228 294-228 66 50-360 280Zm0-202L120-600l360-280 360 280-360 280Z" />
    </svg>
  );
}

export function TechdocsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm80-160h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Z" />
    </svg>
  );
}

export function search() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
    </svg>
  );
}

export const LeftArrowIcon = () => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
  >
    <path
      d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const RightArrowIcon = () => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
  >
    <path
      d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const LeanIXIcon = ({
  fillColor = 'currentColor',
  width = 18,
  height = 12,
}: IconProps) => (
  <SvgIcon
    width={width}
    height={height}
    style={{ fontSize: '18' }}
    viewBox="0 0 18 12"
    fill="none"
  >
    <g id="LeanIX_Logo_90x90">
      <g id="Elemente/Logo/LeanIX-Symbol-Weiss-Copy">
        <g id="Rectangle-Copy-5">
          <path
            id="Mask"
            opacity="0.6"
            d="M11.8918 11.8337C15.1296 11.8337 17.7543 9.22199 17.7543 6.00033C17.7543 2.77866 15.1296 0.166992 11.8918 0.166992C8.65403 0.166992 6.0293 2.77866 6.0293 6.00033C6.0293 9.22199 8.65403 11.8337 11.8918 11.8337Z"
            fill={fillColor}
          />
        </g>
        <path
          id="Rectangle-Copy-6"
          opacity="0.6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6L6.03 0L12.06 6L6.03 12L0 6Z"
          fill={fillColor}
        />
        <path
          id="Combined-Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.83104 1.79297L12.0593 6.00032L7.83104 10.2077C6.7205 9.14619 6.0293 7.65357 6.0293 6.00032C6.0293 4.34707 6.7205 2.85445 7.83104 1.79297Z"
          fill={fillColor}
        />
      </g>
    </g>
  </SvgIcon>
);

export const ConfluenceIcon = ({
  fillColor = 'currentColor',
  width = 13,
  height = 12,
}: IconProps) => (
  <SvgIcon
    width={width}
    height={height}
    style={{ fontSize: '18' }}
    viewBox="0 0 13 12"
    fill="none"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M0.452862 9.16085C0.323704 9.37147 0.178649 9.61588 0.0554522 9.81061C-0.0548186 9.99696 0.00437913 10.2373 0.188584 10.3511L2.77175 11.9407C2.86242 11.9967 2.97178 12.0139 3.07527 11.9885C3.17876 11.9631 3.26772 11.8972 3.32216 11.8056C3.42548 11.6327 3.55862 11.4082 3.70367 11.1678C4.727 9.47877 5.75629 9.68543 7.61219 10.5717L10.1735 11.7897C10.2705 11.8359 10.3821 11.8408 10.4828 11.8034C10.5835 11.7659 10.6647 11.6893 10.708 11.591L11.938 8.80914C12.0249 8.61046 11.9365 8.37879 11.7393 8.28853C11.1988 8.03419 10.1238 7.52749 9.15613 7.06054C5.67482 5.36956 2.71611 5.47885 0.452862 9.16085Z"
        fill={fillColor}
      />
      <path
        id="Vector_2"
        d="M12.0353 2.84767C12.1644 2.63705 12.3095 2.39264 12.4327 2.19791C12.5429 2.01157 12.4838 1.77124 12.2995 1.65743L9.71638 0.0677948C9.62497 0.00622447 9.51209 -0.0146177 9.40472 0.0102479C9.29734 0.0351134 9.20512 0.103453 9.15007 0.19894C9.04675 0.371813 8.91362 0.596349 8.76856 0.836782C7.74523 2.52577 6.71594 2.31912 4.86004 1.4329L2.30668 0.220797C2.20968 0.174625 2.09811 0.169695 1.99741 0.20713C1.89671 0.244565 1.81546 0.321176 1.77217 0.419502L0.542186 3.20137C0.455286 3.40005 0.543708 3.63172 0.740891 3.72197C1.28137 3.97632 2.35636 4.48301 3.32405 4.94997C6.81331 6.63896 9.77202 6.5257 12.0353 2.84767Z"
        fill={fillColor}
      />
    </g>
  </SvgIcon>
);

export const JiraIcon = ({
  fillColor = 'currentColor',
  width = 12,
  height = 12,
}: IconProps) => (
  <SvgIcon
    width={width}
    height={height}
    style={{ fontSize: '18' }}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g id="Group 10">
      <path
        id="Vector"
        d="M11.4983 0H5.71973C5.71973 0.691832 5.99456 1.35533 6.48376 1.84453C6.97295 2.33373 7.63645 2.60856 8.32828 2.60856H9.39277V3.63634C9.39371 5.07569 10.5603 6.24231 11.9996 6.24325V0.501295C11.9996 0.224516 11.7753 0 11.4983 0Z"
        fill={fillColor}
      />
      <path
        id="Vector_2"
        d="M8.63989 2.87927H2.86133C2.86222 4.31863 4.02879 5.48524 5.46819 5.48618H6.53268V6.51725C6.53451 7.95661 7.70188 9.12243 9.14123 9.12243V3.38066C9.14123 3.10379 8.91677 2.87927 8.63989 2.87927Z"
        fill={fillColor}
      />
      <path
        id="Vector_3"
        d="M5.77861 5.75684H0C0 7.19751 1.16793 8.36539 2.60856 8.36539H3.67638V9.39313C3.67732 10.8312 4.84187 11.9973 6.27995 12V6.25818C6.27995 5.98131 6.05548 5.75684 5.77861 5.75684Z"
        fill={fillColor}
      />
    </g>
  </SvgIcon>
);

export const SlackIcon = ({
  fillColor = 'currentColor',
  width = 12,
  height = 12,
}: IconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 12 12" fill="none">
    <g id="_x33_06-slack">
      <g id="Group">
        <path
          id="Vector"
          d="M2.52105 7.58317C2.52105 8.27698 1.95426 8.84377 1.2605 8.84377C0.566768 8.84377 0 8.27695 0 7.58317C0 6.88946 0.566794 6.32269 1.2605 6.32269H2.52105V7.58317Z"
          fill={fillColor}
        />
        <path
          id="Vector_2"
          d="M3.15625 7.58317C3.15625 6.88946 3.72307 6.32269 4.4168 6.32269C5.11054 6.32269 5.67733 6.88949 5.67733 7.58317V10.7397C5.67733 11.4334 5.11051 12.0002 4.4168 12.0002C3.72304 12.0002 3.15625 11.4333 3.15625 10.7397V7.58317Z"
          fill={fillColor}
        />
        <path
          id="Vector_3"
          d="M4.4168 2.52114C3.72304 2.52114 3.15625 1.95432 3.15625 1.26059C3.15625 0.566855 3.72307 6.10352e-05 4.4168 6.10352e-05C5.11054 6.10352e-05 5.67733 0.566881 5.67733 1.26059V2.52114H4.4168Z"
          fill={fillColor}
        />
        <path
          id="Vector_4"
          d="M4.41693 3.15662C5.11067 3.15662 5.67746 3.72341 5.67746 4.41717C5.67746 5.1109 5.11064 5.67764 4.41693 5.67764H1.2605C0.566768 5.67764 0 5.11088 0 4.41717C0 3.72338 0.566794 3.15662 1.2605 3.15662H4.41693Z"
          fill={fillColor}
        />
        <path
          id="Vector_5"
          d="M9.47852 4.41717C9.47852 3.72338 10.0453 3.15662 10.739 3.15662C11.4328 3.15662 11.9995 3.72341 11.9995 4.41717C11.9995 5.1109 11.4327 5.67764 10.739 5.67764H9.47852V4.41717Z"
          fill={fillColor}
        />
        <path
          id="Vector_6"
          d="M8.84335 4.41705C8.84335 5.11078 8.27653 5.67752 7.58279 5.67752C6.88906 5.67752 6.32227 5.11075 6.32227 4.41705V1.26059C6.32227 0.566855 6.88909 6.10352e-05 7.58279 6.10352e-05C8.27655 6.10352e-05 8.84335 0.566881 8.84335 1.26059V4.41705Z"
          fill={fillColor}
        />
        <path
          id="Vector_7"
          d="M7.58279 9.47888C8.27655 9.47888 8.84335 10.0457 8.84335 10.7394C8.84335 11.4331 8.27653 11.9999 7.58279 11.9999C6.88906 11.9999 6.32227 11.4331 6.32227 10.7394V9.47888H7.58279Z"
          fill={fillColor}
        />
        <path
          id="Vector_8"
          d="M7.58279 8.84377C6.88906 8.84377 6.32227 8.27695 6.32227 7.58317C6.32227 6.88946 6.88909 6.32269 7.58279 6.32269H10.7392C11.433 6.32269 11.9997 6.88949 11.9997 7.58317C11.9997 8.27698 11.433 8.84377 10.7392 8.84377H7.58279Z"
          fill={fillColor}
        />
      </g>
    </g>
  </SvgIcon>
);

export const ErrorInfoIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
      fill="white"
    />
    <path
      d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
      fill="#CF5C54"
    />
  </SvgIcon>
);

export const WarningFilledIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 21.5H23L12 2.5L1 21.5ZM13 18.5H11V16.5H13V18.5ZM13 14.5H11V10.5H13V14.5Z"
      fill="#F68512"
    />
  </svg>
);

export function ClineIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19219_3019)">
        <path
          d="M17.524 10.167L16.4425 7.99575V6.7455C16.4425 4.6725 14.779 2.994 12.727 2.994H10.879C11.0125 2.71875 11.086 2.40975 11.086 2.08425C11.0869 1.8113 11.034 1.54086 10.9303 1.28836C10.8267 1.03587 10.6743 0.806287 10.4818 0.612726C10.2894 0.419166 10.0607 0.265425 9.80877 0.160291C9.55688 0.0551561 9.28675 0.000688319 9.0138 0C8.74085 0.000688319 8.47071 0.0551561 8.21882 0.160291C7.96694 0.265425 7.73823 0.419166 7.54579 0.612726C7.35334 0.806287 7.20092 1.03587 7.09724 1.28836C6.99357 1.54086 6.94066 1.8113 6.94155 2.08425C6.94155 2.40975 7.01505 2.71875 7.14855 2.994H5.30055C3.24855 2.994 1.58505 4.6725 1.58505 6.7455V7.99575L0.480297 10.1617C0.368547 10.3792 0.368547 10.6388 0.480297 10.857L1.5843 12.9982V14.2485C1.58505 16.3215 3.2478 18 5.30055 18H12.727C14.779 18 16.4425 16.3215 16.4425 14.2485V12.9975L17.5225 10.8488C17.6298 10.6342 17.6298 10.383 17.524 10.167ZM7.88355 11.9362C7.88415 12.387 7.70597 12.8196 7.38808 13.1392C7.07019 13.4587 6.63855 13.6392 6.1878 13.641C5.73705 13.6392 5.3054 13.4587 4.98751 13.1392C4.66963 12.8196 4.49145 12.387 4.49205 11.9362V8.90475C4.49145 8.45413 4.66952 8.02164 4.98725 7.70209C5.30497 7.38254 5.73643 7.20198 6.18705 7.2C6.41045 7.20049 6.63157 7.24501 6.83777 7.331C7.04396 7.417 7.23119 7.54278 7.38874 7.70117C7.54629 7.85956 7.67109 8.04745 7.75599 8.2541C7.84089 8.46074 7.88424 8.68209 7.88355 8.9055V11.9362ZM13.3473 11.9362C13.3479 12.3869 13.1698 12.8194 12.8521 13.1389C12.5344 13.4585 12.1029 13.639 11.6523 13.641C11.2014 13.6394 10.7696 13.459 10.4515 13.1394C10.1335 12.8198 9.9552 12.3871 9.9558 11.9362V8.90475C9.95521 8.68147 9.9986 8.46026 10.0835 8.25375C10.1684 8.04724 10.2931 7.85947 10.4506 7.70117C10.6081 7.54287 10.7952 7.41714 11.0012 7.33114C11.2073 7.24515 11.4283 7.20059 11.6515 7.2C11.8749 7.20059 12.0959 7.24518 12.302 7.33122C12.5081 7.41725 12.6953 7.54306 12.8528 7.70144C13.0102 7.85982 13.135 8.04767 13.2198 8.25427C13.3047 8.46087 13.348 8.68216 13.3473 8.9055V11.9362Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19219_3019">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CursorIcon() {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6413 5.26047L9.42635 1.1002C9.29665 1.03456 9.14955 1 8.99981 1C8.85007 1 8.70296 1.03456 8.57327 1.1002L0.358666 5.26047C0.13691 5.37279 0 5.58049 0 5.80546V14.1947C0 14.4196 0.13691 14.6273 0.358666 14.7397L8.57365 18.8999C8.70335 18.9656 8.85045 19.0001 9.00019 19.0001C9.14993 19.0001 9.29704 18.9656 9.42673 18.8999L17.6417 14.7397C17.8635 14.6273 18.0004 14.4196 18.0004 14.1947V5.80546C18.0004 5.58049 17.8635 5.37279 17.6417 5.26047H17.6413ZM17.1253 6.14172L9.19495 18.1902C9.14135 18.2714 8.99981 18.2382 8.99981 18.1442V10.255C8.99981 10.0973 8.90378 9.95152 8.74797 9.87236L0.959141 5.92792C0.866582 5.88089 0.904377 5.75674 1.01159 5.75674H16.8723C17.0976 5.75674 17.2383 5.97088 17.1257 6.14205H17.1253V6.14172Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function OpenCodeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M13.5 3.6H4.5V14.4H13.5V3.6ZM18 18H0V0H18V18Z"
        fill="currentColor"
      />
    </svg>
  );
}
